/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PagePamDocumentQueueSummary,
  PagePamVerificationSummary,
  PamDocumentContent,
  PamDocumentSummary,
  PamDocumentSummaryList,
  PamPlayerVerificationStatus,
  PamVerificationDecisionBody,
  PamVerificationDetail,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PagePamDocumentQueueSummaryFromJSON,
    PagePamDocumentQueueSummaryToJSON,
    PagePamVerificationSummaryFromJSON,
    PagePamVerificationSummaryToJSON,
    PamDocumentContentFromJSON,
    PamDocumentContentToJSON,
    PamDocumentSummaryFromJSON,
    PamDocumentSummaryToJSON,
    PamDocumentSummaryListFromJSON,
    PamDocumentSummaryListToJSON,
    PamPlayerVerificationStatusFromJSON,
    PamPlayerVerificationStatusToJSON,
    PamVerificationDecisionBodyFromJSON,
    PamVerificationDecisionBodyToJSON,
    PamVerificationDetailFromJSON,
    PamVerificationDetailToJSON,
} from '../models/index';

export interface ApprovePamVerificationRequest {
    pamPlayerId: string;
    customerId: string;
    pamVerificationDecisionBody: PamVerificationDecisionBody;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeletePamVerificationDocumentRequest {
    pamPlayerId: string;
    documentId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface DenyPamVerificationRequest {
    pamPlayerId: string;
    customerId: string;
    pamVerificationDecisionBody: PamVerificationDecisionBody;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPamVerificationRequest {
    pamPlayerId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPamVerificationDocumentContentRequest {
    pamPlayerId: string;
    documentId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListPamDocumentQueueRequest {
    customerId: string;
    resultStart: number;
    resultEnd: number;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListPamVerificationDocumentsRequest {
    pamPlayerId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListPamVerificationsRequest {
    customerId: string;
    resultStart: number;
    resultEnd: number;
    status?: Array<PamPlayerVerificationStatus>;
    search?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UnlockPamVerificationRequest {
    pamPlayerId: string;
    customerId: string;
    pamVerificationDecisionBody: PamVerificationDecisionBody;
    xClientID?: string;
    xRequestID?: string;
}

export interface UploadPamVerificationDocumentRequest {
    pamPlayerId: string;
    customerId: string;
    authorization: string;
    file: Blob;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PAMVerificationsApi extends runtime.BaseAPI {

    /**
     * Manually approve a failed verification (override KYC). Requires a reason.
     */
    async approvePamVerificationRaw(requestParameters: ApprovePamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamVerificationDetail>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling approvePamVerification().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling approvePamVerification().'
            );
        }

        if (requestParameters['pamVerificationDecisionBody'] == null) {
            throw new runtime.RequiredError(
                'pamVerificationDecisionBody',
                'Required parameter "pamVerificationDecisionBody" was null or undefined when calling approvePamVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/approve`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PamVerificationDecisionBodyToJSON(requestParameters['pamVerificationDecisionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamVerificationDetailFromJSON(jsonValue));
    }

    /**
     * Manually approve a failed verification (override KYC). Requires a reason.
     */
    async approvePamVerification(requestParameters: ApprovePamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamVerificationDetail> {
        const response = await this.approvePamVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Hard-delete a verification document (audited).
     */
    async deletePamVerificationDocumentRaw(requestParameters: DeletePamVerificationDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling deletePamVerificationDocument().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deletePamVerificationDocument().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deletePamVerificationDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/documents/{documentId}`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Hard-delete a verification document (audited).
     */
    async deletePamVerificationDocument(requestParameters: DeletePamVerificationDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePamVerificationDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Manually deny a failed verification to a terminal denied state. Requires a reason.
     */
    async denyPamVerificationRaw(requestParameters: DenyPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamVerificationDetail>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling denyPamVerification().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling denyPamVerification().'
            );
        }

        if (requestParameters['pamVerificationDecisionBody'] == null) {
            throw new runtime.RequiredError(
                'pamVerificationDecisionBody',
                'Required parameter "pamVerificationDecisionBody" was null or undefined when calling denyPamVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/deny`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PamVerificationDecisionBodyToJSON(requestParameters['pamVerificationDecisionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamVerificationDetailFromJSON(jsonValue));
    }

    /**
     * Manually deny a failed verification to a terminal denied state. Requires a reason.
     */
    async denyPamVerification(requestParameters: DenyPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamVerificationDetail> {
        const response = await this.denyPamVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get full detail for a single failed verification, including decrypted PII and history.
     */
    async getPamVerificationRaw(requestParameters: GetPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamVerificationDetail>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling getPamVerification().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPamVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamVerificationDetailFromJSON(jsonValue));
    }

    /**
     * Get full detail for a single failed verification, including decrypted PII and history.
     */
    async getPamVerification(requestParameters: GetPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamVerificationDetail> {
        const response = await this.getPamVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch one document\'s decrypted content (base64) for preview/download.
     */
    async getPamVerificationDocumentContentRaw(requestParameters: GetPamVerificationDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamDocumentContent>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling getPamVerificationDocumentContent().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getPamVerificationDocumentContent().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPamVerificationDocumentContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/documents/{documentId}/content`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamDocumentContentFromJSON(jsonValue));
    }

    /**
     * Fetch one document\'s decrypted content (base64) for preview/download.
     */
    async getPamVerificationDocumentContent(requestParameters: GetPamVerificationDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamDocumentContent> {
        const response = await this.getPamVerificationDocumentContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List un-approved players who have uploaded documents, oldest first by their earliest upload — the FIFO document review queue.
     */
    async listPamDocumentQueueRaw(requestParameters: ListPamDocumentQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagePamDocumentQueueSummary>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPamDocumentQueue().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling listPamDocumentQueue().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling listPamDocumentQueue().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/document-queue`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagePamDocumentQueueSummaryFromJSON(jsonValue));
    }

    /**
     * List un-approved players who have uploaded documents, oldest first by their earliest upload — the FIFO document review queue.
     */
    async listPamDocumentQueue(requestParameters: ListPamDocumentQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagePamDocumentQueueSummary> {
        const response = await this.listPamDocumentQueueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List a player\'s verification documents (metadata only).
     */
    async listPamVerificationDocumentsRaw(requestParameters: ListPamVerificationDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamDocumentSummaryList>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling listPamVerificationDocuments().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPamVerificationDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/documents`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamDocumentSummaryListFromJSON(jsonValue));
    }

    /**
     * List a player\'s verification documents (metadata only).
     */
    async listPamVerificationDocuments(requestParameters: ListPamVerificationDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamDocumentSummaryList> {
        const response = await this.listPamVerificationDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List PAM verifications. With no `status`, returns players across every status (look up anyone); pass one or more `status` values to narrow. `search` matches name or email, case-insensitively.
     */
    async listPamVerificationsRaw(requestParameters: ListPamVerificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagePamVerificationSummary>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listPamVerifications().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling listPamVerifications().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling listPamVerifications().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagePamVerificationSummaryFromJSON(jsonValue));
    }

    /**
     * List PAM verifications. With no `status`, returns players across every status (look up anyone); pass one or more `status` values to narrow. `search` matches name or email, case-insensitively.
     */
    async listPamVerifications(requestParameters: ListPamVerificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagePamVerificationSummary> {
        const response = await this.listPamVerificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlock a failed verification so the player can re-submit KYC. Requires a reason.
     */
    async unlockPamVerificationRaw(requestParameters: UnlockPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamVerificationDetail>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling unlockPamVerification().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling unlockPamVerification().'
            );
        }

        if (requestParameters['pamVerificationDecisionBody'] == null) {
            throw new runtime.RequiredError(
                'pamVerificationDecisionBody',
                'Required parameter "pamVerificationDecisionBody" was null or undefined when calling unlockPamVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:pam-verifications"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/unlock`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PamVerificationDecisionBodyToJSON(requestParameters['pamVerificationDecisionBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamVerificationDetailFromJSON(jsonValue));
    }

    /**
     * Unlock a failed verification so the player can re-submit KYC. Requires a reason.
     */
    async unlockPamVerification(requestParameters: UnlockPamVerificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamVerificationDetail> {
        const response = await this.unlockPamVerificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a verification proof document to a player\'s account.
     */
    async uploadPamVerificationDocumentRaw(requestParameters: UploadPamVerificationDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PamDocumentSummary>> {
        if (requestParameters['pamPlayerId'] == null) {
            throw new runtime.RequiredError(
                'pamPlayerId',
                'Required parameter "pamPlayerId" was null or undefined when calling uploadPamVerificationDocument().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling uploadPamVerificationDocument().'
            );
        }

        if (requestParameters['authorization'] == null) {
            throw new runtime.RequiredError(
                'authorization',
                'Required parameter "authorization" was null or undefined when calling uploadPamVerificationDocument().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadPamVerificationDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['authorization'] != null) {
            headerParameters['Authorization'] = String(requestParameters['authorization']);
        }

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/v1/{customerId}/pam/verifications/{pamPlayerId}/documents`;
        urlPath = urlPath.replace(`{${"pamPlayerId"}}`, encodeURIComponent(String(requestParameters['pamPlayerId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PamDocumentSummaryFromJSON(jsonValue));
    }

    /**
     * Upload a verification proof document to a player\'s account.
     */
    async uploadPamVerificationDocument(requestParameters: UploadPamVerificationDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PamDocumentSummary> {
        const response = await this.uploadPamVerificationDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
